import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import { GameDescriptionDTO } from '../DTO/treasury/explain.interface';

export const explainApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getExplainPage: builder.query<SuccessResponse<GameDescriptionDTO>, null>({
			query: (body) => ({
				url: `/web/game/description/detail`,
				method: 'GET',
			}),
			providesTags: ['ExplainDetail'],
		}),
		updateExplain: builder.mutation<SuccessResponse<any>, GameDescriptionDTO>({
			query: (body) => ({
				url: `/web/game/description/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ExplainDetail'],
		}),
	}),
});

export const { useGetExplainPageQuery, useUpdateExplainMutation } =
	explainApiSlice;
